import { render, staticRenderFns } from "./updateProfile.vue?vue&type=template&id=f2564f90&"
import script from "./updateProfile.vue?vue&type=script&lang=js&"
export * from "./updateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports